import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect, useMemo, useReducer, useRef } from "react";
import { collection, getDocs, limit, orderBy, query, where } from "firebase/firestore";
import { useState } from "react";
import db from "../firebase";
import hbricon from "../otherImg/hbrlitenewicon.png";
import BlogContent from "../BlogContent";
import { actionConsts, actionConts2, reducer } from "./StateManager";
import { DisplayUserPicAndName, sanitizeText } from "./GeneralClasses";
import { HbrAvatarProfile2, Hbrbackarrow, HbrShareIcon } from "./Mycustomsvgicons";
import UseLayout from "./useLayout";
import { AuthContext } from "../AuthContext";
import DivineShorts from "./DivineShorts";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { ConstVariables } from "../newComponents2/ConstantVariables";
import ShareForm from "../newComponents2/ShareForm";

const BloggerPage = () => {
    const [myPost, setMyposts]=useState([]);
    const [shortvideos,setShortVideos]=useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const [state,dispatch]=useReducer(reducer,{progressIndicator: false, userNameToDisplay: "", userProfilePic: "", userBio: "", userEmail: "", shareDialog: false});
    const {user_email} = useContext(AuthContext);
    const searchParams = new URLSearchParams(location.search);
    const hbrUserRef = searchParams.get("hbruserref");
    const hbrUserName = searchParams.get("socialhandle");
    const {width} = UseLayout();
    const shortsRowRef = useRef(null);

    const shareText = `Visit ${sanitizeText(user_email) === hbrUserRef ? 'my' : hbrUserName} profile page on hbrlite app to read and watch edifying blog post and videos`;
    const shareLink = `${ConstVariables.APP_BASE_URL}/profilepage?hbruserref=${hbrUserRef}&socialhandle=${hbrUserName}`;


    const handleClosePage=()=>{
        if (location.state && location.state.from) {
            navigate(location.state.from);
        }else{
            navigate("/");
        }
    };

    useEffect(()=>{
            async function getUserInfo() {
                const userInfo = await DisplayUserPicAndName(hbrUserRef);
                if (userInfo) {
                    const nameFromDB = userInfo.name !== "" ? userInfo.name : hbrUserName;
                    dispatch({type: actionConsts.USER_NAME_DISPLAY, payload: nameFromDB});
                    dispatch({type: actionConsts.USER_PICTURE, payload: userInfo.profilePic});
                    dispatch({type: actionConsts.BIO, payload: userInfo.bio});
                    dispatch({type: actionConts2.USER_EMAIL, payload: userInfo.userEmail});
                }
            }
            getUserInfo();
    },[hbrUserRef, hbrUserName]);

    useEffect(()=>{
        const collectionRef = collection(db,"Blog Posts");
        const q = query(collectionRef,where("blogger_email","==",state.userEmail),orderBy("timestamp","desc"));
        getDocs(q).then((snapshot)=>{
            const myPostdocs = [];
            snapshot.forEach((doc)=>{
                myPostdocs.push(doc.data());
            });
            setMyposts(myPostdocs);
        }).catch((err)=>{
            console.log(err);
        });
    },[state.userEmail]);
    const memoizedPosts = useMemo(()=>myPost,[myPost]);

    useEffect(()=>{
        const collectionref = collection(db,"shorts");
        const q = query(collectionref,orderBy('timestamp','desc'),where("shorts_email","==",state.userEmail),limit(200));
        getDocs(q).then((snapshot)=>{
          const shortVids = [];
          snapshot.forEach((doc)=>{
              shortVids.push(doc.data());
          });
         setShortVideos(shortVids);
        }).catch((err)=>{
          console.log(err)
        });
       },[state.userEmail]);
       const memoizedshortvideos = useMemo(()=>shortvideos,[shortvideos]);

       const showMoreShorts=(offset)=>{
        shortsRowRef.current.scrollLeft += offset;
    };


    return (  
        <div className="bloggerpage flex-column1">
            <div className="topbloggerpage">
                <div className="coverbloggerphoto flex-row2" style={{backgroundImage:`url(${state.userProfilePic !== "" ? state.userProfilePic : hbricon})`}}>

                    {state.userProfilePic !== "" ? (<img src={state.userProfilePic} alt=""/>)
                        : 
                        <div className="smallerAvaterforblogphoto">
                            <HbrAvatarProfile2 width={width <= 1024 ? "4em" : "10em"} height={width <= 1024 ? "4em" : "10em"}/>
                        </div>
                    }

                    <div className="bp_nameposts flex-column2">
                        <h2>{state.userNameToDisplay}</h2>
                        <p style={{color:"#0251EB",fontWeight:"bold"}}>{myPost && myPost.length <= 1 ?
                         `${myPost.length} Post` : `${myPost.length} Posts`}
                        </p>
                    </div>
                    
                    <div style={{position:"absolute", left:"0px", top:"2em", backgroundColor:"#101010", borderRadius:"50%"}}>
                        <Hbrbackarrow width={"1.8em"} height={"1.8em"} fillColour={"white"} handleClick={() => handleClosePage()}/>
                    </div>
                    
                    <div className="exittomainblog flex-row2">
                        <HbrShareIcon width={"1.6em"} height={"1.6em"} fillColour={"black"} handleClick={()=>dispatch({type:actionConts2.SHARE_DIALOG, payload: true})}/>
                        <h3>Share</h3>
                    </div>
    
                </div>
            </div>

            {state.shareDialog && 
                <ShareForm
                    message={shareText}
                    title={hbrUserName}
                    url={shareLink}
                    formTitle={"Share profile link"}
                    closeForm={()=>dispatch({type:actionConts2.SHARE_DIALOG, payload: false})}
                />
            }

            <div className="bloggerpagebody">
                <div className="leftblogbodypage flex-column2">
                    <div className="bpabouttext">
                        <h2>About {state.userNameToDisplay}</h2>
                       
                        {state.userBio !== "" ? 
                        <pre>{state.userBio}</pre> : <pre>N/A Information will be available when user updates profile</pre>
                        }
                    </div>

                    <div className="shortvideoviewprofilepage">
                        {width <= 1024 && 
                              <button onClick={()=>showMoreShorts(-320)} style={{border:"none",borderRadius:"50%",padding:"10px",cursor:"pointer"}} className="prev_shorts">
                              <ArrowBackIos/>
                            </button>
                        }
                      
                        <div className={`shortvideosprofilepage ${width <= 1024 ? 'mobile' : 'desktop'}`} style={{gap:"10px"}} ref={shortsRowRef}>
                            {memoizedshortvideos && memoizedshortvideos.map((data,index)=>(
                                <DivineShorts
                                key={index}
                                shorts_email={data.shorts_email}
                                shorts_thumbnail={data.shorts_thumbnail}
                                index={index}
                                shorts_id={data.shorts_id}
                                />
                            ))}
                        </div>

                        {width <= 1024 &&
                            <button onClick={()=>showMoreShorts(320)} style={{border:"none",borderRadius:"50%",padding:"10px",cursor:"pointer"}} className="next_shorts">
                               <ArrowForwardIos/>
                            </button>
                        }
                     
                    </div>
                </div>

                <div className="rightblogbodtpage flex-column2">
                  <div className="mypostsheading flex-row">
                    <h2 style={{color:"white"}}>{`${sanitizeText(user_email) === hbrUserRef ? 'Your Posts' : 'Posts from ' + state.userNameToDisplay}`}</h2>
                  </div>

                    <div className="myblogcollection">
                        {memoizedPosts && memoizedPosts.map((post,index)=>(
                            <BlogContent 
                            key={index}
                            postID ={post.postID}
                            blog_message = {post.blog_message}
                            blogger_email = {post.blogger_email}
                            blog_date = {post.blog_date}
                            blogger_name = {post.blogger_name}
                            blogger_profile_pic = {post.blogger_profile_pic}
                            videolink = {post.video_url}
                            video_thumb={post.video_thumb}
                            images={post.images}
                            edifiedby = {post.edifiedby}
                            timestamp = {post.timestamp}
                            />
                        ))}
                    </div>
                </div>

            </div>

            {/* <div className="bloggerpagebodyphone">
                <div className="leftblogbodypagephone flex-column2">
                    <div className="bpabouttext">
                        <h2>About {state.userNameToDisplay}</h2>
                       
                       {state.userBio !== "" ? 
                       <pre>{bloggerInfo && bloggerInfo.bloggerBio}</pre> : <pre>N/A Information will be available when user updates profile</pre>
                       }
                    </div>
                </div>

                <div className="rightblogbodtpagephone flex-column2">
                    <div className="mypostsheadingphone flex-row">
                        <h2 style={{color:"white"}}>{bloggerInfo && bloggerInfo.bloggerName} Blog Posts</h2>
                    </div>

                    
                    <div className="myblogcollection">
                        {myPost && myPost.map((post)=>(
                            <BlogContent 
                                key={post.timestamp}
                                postID ={post.postID}
                                blog_message = {post.blog_message}
                                blogger_email = {post.blogger_email}
                                blog_date = {post.blog_date}
                                blogger_name = {post.blogger_name}
                                blogger_profile_pic = {post.blogger_profile_pic}
                                videolink = {post.youtube_url}
                                blog_pic = {post.blog_pic}
                                second_image = {post.second_image}
                                third_image = {post.third_image}
                                fourth_image = {post.fourth_image}
                                fifth_image = {post.fifth_image}
                                sixth_image = {post.sixth_image}
                                edifiedby = {post.edifiedby}
                                timestamp = {post.timestamp}
                                bloggerpageid={post.bloggerpageid}
                            />
                        ))}
                    </div>
                </div>
            </div> */}
        </div>
    );
}
export default BloggerPage;